import type { ReactNode } from "react";
import { Modal, Button } from "flowbite-react";
import { useTranslation } from "react-i18next";

const ConfirmationModal = ({
  showConfirmationModal,
  title,
  confirmationMessage,
  isDisabled,
  setShowConfirmationModal,
  onContinuePress,
  isContinueAvailable,
  cancelLabel,
  confirmLabel,
}: {
  showConfirmationModal: boolean;
  title?: string;
  confirmationMessage: ReactNode;
  isDisabled?: boolean;
  isContinueAvailable?: boolean;
  setShowConfirmationModal: (show: boolean) => void;
  onContinuePress: () => void;
  cancelLabel?: string;
  confirmLabel?: string;
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      show={showConfirmationModal}
      onClose={() => setShowConfirmationModal(false)}
      size="md"
    >
      <div className="p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900">
            {title ??
              t("settingsUI.confirmRecalculation", "Confirm Recalculation")}
          </h3>
          <button
            type="button"
            className="text-gray-400 hover:text-gray-600"
            onClick={() => setShowConfirmationModal(false)}
          >
            <span className="sr-only">{t("common.close", "Close")}</span>
            <svg
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="mb-6 text-gray-700 leading-relaxed space-y-3">
          {confirmationMessage}
        </div>

        <div className="flex gap-3 justify-end">
          <Button color="gray" onClick={() => setShowConfirmationModal(false)}>
            {cancelLabel ?? t("common.close", "Close")}
          </Button>
          {isContinueAvailable && (
            <Button
              color="blue"
              onClick={() => {
                setShowConfirmationModal(false);
                onContinuePress();
              }}
              disabled={isDisabled}
            >
              {confirmLabel ?? t("common.continue", "Continue")}
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
